<template>
  <div>
    <Layout>
      <div class="home_content">
        <Swiper  :showIndicator="swiperData.showIndicator" :autoPlay="swiperData.autoPlay" :interval="swiperData.interval">
          <Slide v-for="(item,index) in imageList" :key="index">
            <img :src="item" />
          </Slide>
        </Swiper>
      </div>
    </Layout>
  </div>
</template>
<script>
import Layout from '../public/layout'
import config from '@/config'
import { Swiper, Slide } from 'vue-swiper-component'
export default {
  data() {
    return {
      imageList: config.pageData.home.showImg,
      swiperData: {
        showIndicator: false,
        autoPlay: true,
        interval: 3000,

      }
    }
  },
  components: {
    Layout,
    Swiper,
    Slide
  },
}
</script>
<style lang="less" scoped>
  @import "style";
</style>
<style lang="less">
// .wh_content {
//   height: calc(100vh - 121px);
// }
</style>
